import { http } from "../http-common";

export interface ChatPromptRequestDto {
  topicId?: string | null;
  newTopicTitle?: string;
  text?: string;
  images?: string[];
  systemMessage?: string;
}

export interface ChatPromptResponseDto {
  reply: string;
  topicId: string;
  messageIds: { user?: string | number; assistant?: string | number };
  credit: number;
}

export interface ChatTopicDto {
  id?: string;
  topicId?: string;
  title?: string;
  name?: string;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: any;
}

export interface ChatMessageDto {
  id?: string | number;
  messageId?: string | number;
  role?: string;
  content?: string;
  text?: string;
  reply?: string;
  createdAt?: string;
  images?: any;
  imageUrls?: any;
  attachments?: any;
  hasAudio?: boolean;
  [key: string]: any;
}

export interface ChatReportResponseDto {
  report: string;
  requestUuid: string;
  usedRequestUuids: string[];
  requestCount: number;
  startDate: string;
  endDate: string;
  customInstruction?: string;
  [key: string]: any;
}

// Sesli girişten metin üret (Speech to Text)
const transcribe = (audioFile: File) => {
  const formData = new FormData();
  formData.append("audio", audioFile, "audio.webm");
  return http.post<{ text: string }>("/transcribe", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Chat (text ve/veya görsel gönderimi)
const chat = (data: ChatPromptRequestDto) => {
  return http.post<ChatPromptResponseDto>("/chat", data);
};

const listTopics = () => {
  return http.get<ChatTopicDto[] | { content: ChatTopicDto[] }>("/chat/topics");
};

const deleteTopic = (topicId: string) => {
  return http.delete(`/chat/topics/${topicId}`);
};

const listMessages = (topicId: string, page = 0, size = 20) => {
  return http.get<
    | ChatMessageDto[]
    | { content: ChatMessageDto[] }
    | { data: ChatMessageDto[] }
  >(`/chat/topics/${topicId}/messages`, {
    params: { page, size },
  });
};

// Metni sese çevir (Text to Speech)
const tts = (data: { text: string; voice?: string }) => {
  return http.post<Blob>("/tts", data, {
    responseType: "blob", // Ses dosyası için önemli!
    headers: { "Content-Type": "application/json" },
  });
};

const saveAssistantAudio = (messageId: string | number, audio: Blob) => {
  const formData = new FormData();
  formData.append("audio", audio, "assistant-response.mp3");
  return http.post(`/chat/messages/${messageId}/audio`, formData);
};

const getAssistantAudio = (messageId: string | number) =>
  http.get<Blob>(`/chat/messages/${messageId}/audio`, { responseType: "blob" });

const generateReport = (params: {
  startDate: string;
  endDate: string;
  customInstruction?: string;
}) => {
  return http.get<ChatReportResponseDto>("/chat/report", {
    params,
  });
};

const OpenAIAssistantService = {
  transcribe,
  chat,
  tts,
  saveAssistantAudio,
  getAssistantAudio,
  listTopics,
  deleteTopic,
  listMessages,
  generateReport,
};

export default OpenAIAssistantService;
